import t from './strings'
import { VehicleType } from '../../../constants'

export const SignUpDetailsText = {
  content: [
    {
      subtitle: t.jpBicycle(),
      text: [
        t.whatToBringOne(),
        t.jpBicycleReq(),
        t.jpBicycleForeignReq(),
      ],
      trackingId: VehicleType.Bicycle,
    },
    {
      subtitle: t.jpScooter(),
      text: [
        t.whatToBringOne(),
        t.jpOtherReq(),
        t.jpOtherForeignReq(),
        t.jpOtherInsuranceReq(),
      ],
      trackingId: VehicleType.Scooter,
    },
    {
      subtitle: t.jpMotorcycle(),
      text: [
        t.whatToBringOne(),
        t.jpOtherReq(),
        t.jpOtherForeignReq(),
        t.jpOtherInsuranceReq(),
        t.jpOtherVoluntaryReq(),
        t.jpOtherPhotoReq(),
      ],
      trackingId: VehicleType.Motorcycle,
    },
    {
      subtitle: t.jpCar(),
      text: [
        t.whatToBringOne(),
        t.jpOtherReq(),
        t.jpOtherForeignReq(),
        t.jpOtherInsuranceReq(),
        t.jpOtherVoluntaryReq(),
        t.jpOtherSafetyCertReq(),
        t.jpOtherPhotoReq(),
      ],
      trackingId: VehicleType.Car,
    },
  ],
}
